import { Provider } from '@angular/core';

export interface LoggerModuleConfig {
  loader?: Provider;
}

export enum LogLevel {
  All = 0,
  Debug = 1,
  Info = 2,
  Warn = 3,
  Error = 4,
  Fatal = 5,
  Off = 6,
}

export class LoggerConfig {
  publisher: LogPublisherConfig[];
}

export class LogPublisherConfig {
  loggerName: string;
  loggerLocation: string;
  isActive: boolean;

  constructor(options: {
    loggerName?: string,
    loggerLocation?: string,
    isActive?: boolean,
  } = {}) {
    this.loggerName = options.loggerName || 'console';
    this.loggerLocation = options.loggerLocation || '';
    this.isActive = options.isActive || true;
  }
}

export class LogEntry {
  // Public properties
  entryDate: Date = new Date();
  message = '';
  level: LogLevel = LogLevel.Debug;
  extraInfo: any[] = [];
  logWithDate = true;

  buildLogString(): string {
    let ret = '';

    // if(this.logWithDate) {
    //   ret = new Date() + " - ";
    // }
    // ret += "Type: " + LogLevel[this.level];
    // ret += " - Message: " + this.message;
    ret += this.message;
    if (!this.extraInfo) { return; }
    if (this.extraInfo.length) {
      ret += ' - Extra Info: ' + this.formatParams(this.extraInfo);
    }

    return ret;
  }

  private formatParams(params: any[]): string {
    let ret: string = params.join(',');

    if (params.some(p => typeof p == 'object')) {
      ret = '';
      for (const item of params) {
        ret += JSON.stringify(item) + ',';
      }
    }

    return ret;
  }
}
